import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import "./Placeholders.scss";
import { IUButton } from "../../widgets";
import Button from "../../button/Button";
import { useTranslation } from "react-i18next";

interface IProps {
    title: string;
    description: string;
    message?: React.ReactNode;
    imagePath?: string;
    icon?: IconDefinition;
    button?: IUButton;
    altButton?: JSX.Element;
}

export default function EmptyPlaceholder(props: IProps) {
    const { t } = useTranslation();

    return (
        <div className="emptyPlaceholderWrapper">
            <div className="emptyPlaceholderContainer">
                {props.imagePath && <img src={props.imagePath} alt={props.title} />}
                <div className="emptyPlaceholderColumn">
                    <div className="emptyPlaceholderTitle">{props.title}</div>
                    <div className="emptyPlaceholderDescription">{props.description}</div>
                </div>
                {props.message && <>{props.message}</>}
                {props.icon && <FontAwesomeIcon className="emptyPlaceholderIcon" icon={props.icon} />}
                {props.button && (
                    <Button variant="secondary">
                        {props.button.icon && <FontAwesomeIcon icon={props.button.icon} />}
                        {props.button.title && <p>{t(props.button.title)}</p>}
                    </Button>
                )}
                {props.altButton}
            </div>
        </div>
    );
}
